module.exports = __webpack_public_path__ + "img/BG831919536.3aca52bc.svg";